import React from 'react';
import Hero from '../components/Hero';
import ContactForm from '../components/ContactForm';
import { companyData, siteImages } from '../data';
import SEO from '../components/SEO';
import SchemaMarkup from '../components/SchemaMarkup';
import { getOptimizedImageUrl } from '../lib/utils';
import { useLanguage } from '../context/LanguageContext';

export default function Contact() {
  const { lang, t } = useLanguage();

  const breadcrumbs = lang === 'da'
    ? [
        { name: 'Forside', href: '/' },
        { name: 'Kontakt', href: '/kontakt' }
      ]
    : [
        { name: 'Home', href: '/en' },
        { name: 'Contact', href: '/en/contact' }
      ];

  return (
    <div className="bg-white">
      <SEO 
        title={t('seo.contact.title')} 
        description={t('seo.contact.description')}
      />
      <SchemaMarkup type="breadcrumbs" data={breadcrumbs} />

      <Hero
        title={t('contactPage.title')}
        subtitle={t('contactPage.subtitle')}
        image={siteImages.contact}
        showCta={false}
      />

      <section className="py-24 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20">
          <div>
            <h2 className="text-3xl font-bold text-slate-900 uppercase mb-8">
              {t('contactPage.infoTitle')}
            </h2>
            <p className="text-slate-600 text-lg mb-12 leading-relaxed">
              {t('contactPage.infoDesc')}
            </p>

            <div className="space-y-8">
              <div className="flex items-start">
                <div>
                  <h3 className="text-sm font-bold uppercase tracking-widest text-slate-900 mb-1">
                    {t('contactPage.phone')}
                  </h3>
                  <a href={`tel:${companyData.phoneClean}`} className="text-slate-600 text-lg hover:text-blue-700 transition-colors">
                    {companyData.phone}
                  </a>
                </div>
              </div>

              <div className="flex items-start">
                <div>
                  <h3 className="text-sm font-bold uppercase tracking-widest text-slate-900 mb-1">
                    {t('contactPage.email')}
                  </h3>
                  <a href={`mailto:${companyData.email}`} className="text-slate-600 text-lg hover:text-blue-700 transition-colors">
                    {companyData.email}
                  </a>
                </div>
              </div>

              <div className="flex items-start">
                <div>
                  <h3 className="text-sm font-bold uppercase tracking-widest text-slate-900 mb-1">
                    {t('contactPage.location')}
                  </h3>
                  <p className="text-slate-600 text-lg">
                    {companyData.address[lang]}
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div>
                  <h3 className="text-sm font-bold uppercase tracking-widest text-slate-900 mb-1">
                    {t('contactPage.availability')}
                  </h3>
                  <p className="text-slate-600 text-lg">
                    {t('contactPage.availabilityValue')}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-slate-50 p-6 sm:p-16 border border-slate-100">
            <h2 className="text-2xl font-bold text-slate-900 uppercase mb-8">
              {t('contactPage.formTitle')}
            </h2>
            <ContactForm />
          </div>
        </div>
      </section>

      <section className="h-[400px] w-full grayscale">
        <img 
          src={getOptimizedImageUrl(siteImages.homeHero, 1200, 80)}
          srcSet={`${getOptimizedImageUrl(siteImages.homeHero, 600, 80)} 600w, ${getOptimizedImageUrl(siteImages.homeHero, 1200, 80)} 1200w, ${getOptimizedImageUrl(siteImages.homeHero, 1920, 80)} 1920w`}
          sizes="100vw"
          className="w-full h-full object-cover" 
          alt="Porthos Maritime - Professionel maritim assistance og rådgivning" 
          loading="lazy"
        />
      </section>
    </div>
  );
}
